import React from "react";
import { createComponent } from "@lit/react";
//#region src/lib/create-lit-component.ts
/**
* Wrapper around @lit/react's createComponent that works with Lit mixin-based classes.
*
* Lit mixin chains (e.g. TailwindComponent(DataComponent(LitElement))) produce types
* that don't structurally satisfy TypeScript's `extends HTMLElement` constraint,
* even though they correctly extend HTMLElement at runtime through LitElement.
*
* Also adds DataComponentInterface to the return type since the mixin-inherited
* properties are lost during DTS generation (widgets-core's compiled output
* references a global LitConstructor type that isn't included in dist/).
*/
const createLitComponent = (options) => {
	return createComponent({
		...options,
		react: React
	});
};
//#endregion
export { createLitComponent };
